var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fill-height":"","fluid":"","grid-list-sm":""}},[_c('v-layout',[_c('v-flex',{attrs:{"md12":"","lg12":""}},[_c('HospedesAvulsosList')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }